import React, { Fragment, ReactNode } from 'react';
import styled from 'styled-components';
import Asterisk from './Asterisk';
import { SelectChange } from '../types';

type Size = 'half' | 'full';

interface Props {
   size?: Size;
   label: string;
   required?: boolean;
   name?: string;
   defaultValue?: string | undefined;
   value: string | any;
   children: HTMLOptionElement | ReactNode;
   onChange: (e: SelectChange) => void;
}

export default ({ size = 'full', label, required = false, name, children, value = '', onChange }: Props): JSX.Element => (
   <Fragment>
      <LabelContainer>
         <Label htmlFor={name}>
            {label}
            {required && <Asterisk />}
         </Label>
      </LabelContainer>
      <SelectContainer size={size}>
         <Select open={false} onChange={onChange} value={value} name={name}>
            <option value="" disabled hidden>
               Select tier option
            </option>
            {children}
         </Select>
      </SelectContainer>
   </Fragment>
);

const halfSize = 200;
const fullSize = 400;

const SelectContainer = styled.div`
   margin: 1em auto;
   position: relative;
   max-width: ${({ size = 'full' }: { size: Size }) => (size === 'half' ? `${halfSize}` : `${fullSize}`)}px;
   width: 100%;
   display: inline-block;
`;

const Select = styled.select`
   display: block;
   font-size: 16px;
   font-family: sans-serif;
   color: ${({ theme }) => theme.almostBlack};
   line-height: 1.3;
   padding: 0.9em 1.4em 0.5em 0.8em;
   width: 100%;
   box-sizing: border-box;
   margin: 0;
   border: 1px solid ${({ theme }) => theme.primaryGrey};
   box-shadow: 0 1px 0 1px rgba(0, 0, 0, 0.04);
   border-radius: 10px;
   -moz-appearance: none;
   -webkit-appearance: none;
   appearance: none;
   background-color: #fff;
   background-image: url(${({ open }: { open: boolean }) => `https:icon.now.sh/chevron/${open ? 'up' : 'down'}`});
   /* linear-gradient(to bottom, #ffffff 0%, #e5e5e5 100%); */
   background-repeat: no-repeat, repeat;
   /* arrow icon position (1em from the right, 50% vertical) , then gradient position*/
   background-position: right 0.7em top 50%, 0 0;
   /* icon size, then gradient */
   background-size: 0.65em auto, 100%;
   /* Hide arrow icon in IE browsers */
   ::-ms-expand {
      display: none;
   }
   &:hover {
      border-color: #888;
      cursor: pointer;
   }
   &:focus {
      border-color: #aaa;
      box-shadow: 0 0 1px 3px rgba(59, 153, 252, 0.7);
      box-shadow: 0 0 0 3px -moz-mac-focusring;
      color: #222;
      outline: none;
   }

   &[disabled] {
      color: ${({ theme }) => theme.primaryGrey};
      background-color: ${({ theme }) => theme.disabled};
      cursor: default;
      border: 1px solid ${({ theme }) => theme.disabled};
   }
`;

const LabelContainer = styled.div`
   margin: 0 auto 0.9em auto;
   position: relative;
`;

const Label = styled.label`
   font-weight: 600;
   font-size: 1.2em;
   position: absolute;
   left: 75px;
   top: -20px;
   color: ${({ theme }) => theme.primaryBlueDark};
   @media only screen and (max-width: 400px) {
      left: 10px;
   }
`;
